"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIsTeacherOfFirebaseGroup = exports.updateFirebaseGroupUpdateFields = void 0;
const lodash_1 = require("lodash");
const utils_1 = require("../../utils");
function updateFirebaseGroupUpdateFields(data) {
    const updateFields = {};
    if (!(0, lodash_1.isNil)(data.name))
        updateFields['name'] = data.name;
    if (!(0, lodash_1.isNil)(data.ownerId))
        updateFields['ownerId'] = data.ownerId;
    if (!(0, lodash_1.isNil)(data.teachers))
        updateFields['teachers'] = data.teachers;
    if (!(0, lodash_1.isNil)(data.students))
        updateFields['students'] = data.students;
    if (!(0, lodash_1.isNil)(data.studentDisplayName))
        updateFields['studentDisplayName'] = data.studentDisplayName;
    const cleaned = (0, utils_1.omitDeepUndefined)(updateFields);
    return cleaned;
}
exports.updateFirebaseGroupUpdateFields = updateFirebaseGroupUpdateFields;
function userIsTeacherOfFirebaseGroup(group, teacherId) {
    return group.teachers.includes(teacherId);
}
exports.userIsTeacherOfFirebaseGroup = userIsTeacherOfFirebaseGroup;
//# sourceMappingURL=FirebaseGroup.js.map